import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Paper from '@mui/material/Paper';
import InputBase from '@mui/material/InputBase';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import DirectionsIcon from '@mui/icons-material/Directions';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';

import { SET_FILTER, SET_LOADING } from '../../actions/types';

const Search = () => {
  const dispatch = useDispatch();
  const { filter, loading } = useSelector(state => state.fpzReducer);

  return (
    <Paper
      component="form"
      sx={{ p: '1px 1px', display: 'flex', alignItems: 'center', width: '100%' }}
      onSubmit={(e) => { e.preventDefault(); }}
    >
      {/*<IconButton sx={{ p: '10px' }} aria-label="menu">
        <MenuIcon />
      </IconButton>*/}
      <TextField
        sx={{
          ml: 1,
          flex: 1
        }}
        variant="standard"
        placeholder="Search wells..."
        inputProps={{ 'aria-label': 'search...' }}
        value={filter}
        onChange={(e) => {
          dispatch({ type: SET_FILTER, payload: e.target.value });
          dispatch({ type: SET_LOADING, payload: true });
        }}

      />
      <IconButton type="button" sx={{ p: '10px' }} aria-label="search">
        {loading ? <CircularProgress /> : <SearchIcon />}
      </IconButton>
      {/*<IconButton type="button" sx={{ p: '10px' }} aria-label="search" size="small">
        Show All
        <Checkbox
          checked={true}
          onChange={(e) => console.log() }
          title="View Cartofact Wells"
        />
      </IconButton>*/}
    </Paper>
  );
}


export default Search;